import { Phone, MapPin, Navigation, ArrowUpRight, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, MAPS_URL, SHOP_URL, WORKING_HOURS } from "@/constants/site";

export default function Footer() {
  return (
    <footer className="border-t border-[#39FF14]/20 bg-black" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-display text-2xl font-extrabold tracking-tight">
              АУТО<span className="text-[#39FF14]">ДЕ·1</span> ЕООД
            </p>
            <p className="mt-4 max-w-xs text-sm text-zinc-500">
              Професионален автосервиз в Хасково. Диагностика, механика, автоклиматици,
              акумулатори и резервни части с гарантирани произход и качество.
            </p>
          </div>

          <div>
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">Контакти</p>
            <div className="space-y-4 text-sm">
              <a data-testid="footer-call-link" href={PHONE_TEL} className="flex items-center gap-3 text-zinc-300 transition-colors duration-300 hover:text-[#39FF14]">
                <Phone size={16} className="shrink-0 text-[#39FF14]" /> {PHONE_DISPLAY}
              </a>
              <p className="flex items-start gap-3 text-zinc-300">
                <MapPin size={16} className="mt-0.5 shrink-0 text-[#39FF14]" /> {ADDRESS}
              </p>
              <a
                data-testid="footer-navigate-link"
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-[#39FF14]/40 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white transition-colors duration-300 hover:bg-[#39FF14]/10"
              >
                <Navigation size={14} className="text-[#39FF14]" /> Навигация в Google Maps
              </a>
            </div>
          </div>

          <div>
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">Работно време</p>
            <ul className="space-y-2 text-sm" data-testid="footer-working-hours">
              {WORKING_HOURS.map((w) => (
                <li key={w.day} className="flex items-center justify-between gap-4 max-w-[240px]">
                  <span className="flex items-center gap-2 text-zinc-400">
                    <Clock size={13} className="shrink-0 text-[#39FF14]" /> {w.day}
                  </span>
                  <span className={w.hours === "Затворено" ? "text-zinc-600" : "font-semibold text-zinc-200"}>
                    {w.hours}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.35em] text-[#39FF14]">Онлайн магазин</p>
            <p className="mb-4 text-sm text-zinc-500">
              Акумулатори, зарядни и стартови устройства — продажба, монтаж и гаранция.
            </p>
            <a
              data-testid="footer-shop-link"
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-bold text-[#39FF14] transition-colors duration-300 hover:text-[#32E612]"
            >
              www.akumulator.pro <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-zinc-600 sm:flex-row sm:items-center">
          <p>© 2026 АутоДе 1 ЕООД. Всички права запазени.</p>
          <p className="font-display uppercase tracking-widest">Хасково · България</p>
        </div>
      </div>
    </footer>
  );
}
